// src/components/EmptyState.js
import React from 'react';
import styles from './EmptyState.module.css';

const EmptyState = ({ message, icon }) => (
  <div className={styles.emptyState}>
    {icon && <span className={styles.icon}>{icon}</span>}
    <p className={styles.message}>{message}</p>
  </div>
);

export default EmptyState;